import { useEffect, useState, } from 'react';
import { useSelector } from 'react-redux';
import agentComponent from './../businesses/agent';
import VerticalBarChart from '../components/businessInteligence/VerticalBarChart';
import MultiaxisLineChart from '../components/businessInteligence/MultiaxisLineChart';
import HorizontalBarChart from '../components/businessInteligence/HorizontalBarChart';
import FullPageLoader from '../components/Layout/FullPageLoader';
import ProgressBar from '../components/businessInteligence/ProgressBar';

export default function BIPage() {
    const [agent, setAgent] = useState();
    const [loading, setLoading] = useState(true);
    const [agentPerformance, setAgentPerformance] = useState(null);
    const agentId = useSelector(state => state.viewAgentId);

    useEffect(() => {
        (async () => {
            setAgent(await agentComponent.profile(agentId));
            const agentPerformance = await agentComponent.myPerformance(agentId)

            if (agentPerformance) 
                setAgentPerformance(agentPerformance)
                setLoading(false)
        })();
    }, []);

	return <>
		<div className='layout'>
            <div className='c-w-flex'>
                <div className='banner'>
                    {`${agent?.UserName}'s Performance in detail`}
                </div>
            </div>

            <div className="full-rel">
                <FullPageLoader loading={loading} />

                <div className='full-abs md:p-5 p-3'>
                    <div className='flex flex-col gap-4'>
                        <div className="grid md:grid-cols-3 gap-4">
                            {
                                agentPerformance &&
                                Object.entries(agentPerformance.case).map(([key, value], idx) => 
                                    (
                                        <div key={'case_' + idx} className='rounded-[10px] bg-white shadow-md p-4'>
                                            <p className='font-semibold text-gray-two text-sm capitalize'>Total { key }</p>

                                            <div className='mt-2 flex flex-col gap-1'>
                                                <div className='flex items-center'>
                                                    <p className='font-medium text-gray-one'>Completed Case</p>
                                                    <p className='font-medium text-primary ml-auto text-4xl'>{ value.completed }</p>
                                                </div>

                                                <div className='flex items-center'>
                                                    <p className='font-medium text-gray-one'>Pending Case</p>
                                                    <p className='font-medium text-orange ml-auto text-4xl'>{ value.pending }</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )
                            }
                        </div>

                        {
                            agentPerformance &&
                            <>
                                <div className='grid md:grid-cols-5 gap-4'>
                                    <div className='md:col-span-2 flex flex-col rounded-[10px] bg-white shadow-md p-4'>
                                        <p className='font-semibold text-gray-two text-sm mb-4'>Annual Trip Target</p>

                                        <div className='mb-4'>
                                            <p className='text-xs font-medium text-gray-two inline-block'>Sales Commission:</p>
                                            {
                                                agentPerformance?.tripAchievement?.label?.map((item, idx) => (
                                                    item === 'Sales Commission' ?
                                                    <span key={ 'sales_commission_'+idx } className='text-sm text-gray-one font-semibold ml-1'>
                                                        RM { agentPerformance?.tripAchievement?.data[idx].toLocaleString() }
                                                    </span> : null
                                                ))
                                            }
                                        </div>

                                        <div className='flex-1 flex flex-col-reverse justify-between'>
                                            {
                                                agentPerformance?.tripAchievement?.label?.map((item, idx) => (
                                                    item !== 'Sales Commission' ? <ProgressBar key={ 'progress_'+idx } sales={ agentPerformance?.tripAchievement } index={idx} /> : null
                                                ))
                                            }
                                        </div>
                                    </div>

                                    <div className='md:col-span-3 rounded-[10px] bg-white shadow-md p-4 pl-2'>
                                        <p className='font-semibold text-gray-two text-sm mb-4 ml-2'>Annual Trip Target by Monthly</p>
                                        <MultiaxisLineChart chartData={ agentPerformance?.tripAchievementProgressing } monthly={ true } title='Sales Commission (RM))' ratio='4' bp='0.6' />
                                    </div>
                                </div>

                                <div className='grid md:grid-cols-3 gap-4'>
                                    <div className='rounded-[10px] bg-white shadow-md p-4 pl-2'>
                                        <p className='font-semibold text-gray-two text-sm mb-4 ml-2'>Recruitment by Yearly</p>
                                        <VerticalBarChart chartData={ agentPerformance?.recruitment } color='#6366f1' title='Total Recruitment' />
                                    </div>

                                    <div className='rounded-[10px] bg-white shadow-md p-4 pl-2'>
                                        <p className='font-semibold text-gray-two text-sm mb-4 ml-2'>Project Sales by Yearly</p>
                                        <VerticalBarChart chartData={ agentPerformance?.project } color='#a5b3fc' title='Project Sales (RM)' />
                                    </div>

                                    <div className='rounded-[10px] bg-white shadow-md p-4 pl-2'>
                                        <p className='font-semibold text-gray-two text-sm mb-4 ml-2'>Sales Commission by Yearly</p>
                                        <VerticalBarChart chartData={ agentPerformance?.commission?.yearly } color='#a855f7' title='Sales Commission (RM))' />
                                    </div>
                                </div>

                                <div className='grid grid-cols-1 gap-4'>
                                    <div className='rounded-[10px] bg-white shadow-md p-4 pl-2'>
                                        <p className='font-semibold text-gray-two text-sm mb-4 ml-2'>Sales Commission by Monthly</p>
                                        <VerticalBarChart chartData={ agentPerformance?.commission?.monthly } monthly={ true } color='#f97315' title='Sales Commission (RM)' ratio='5' bp='0.6' />
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
		</div>
	</>
}